/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { BulkRestockIcon } from "../../../../../../assets/svgIcons";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";

const RestockCover = () => {
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Inventory - Fast Track Procurement"
      description="Create a purchase order, add the goods to your stock position, and generate the bill, all in one step."
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Fast-Track Procurement</h4>
            <p>
              Create a purchase order, add the goods to your stock position, and
              generate the bill, all in one step.
            </p>
          </div>

          <div className={globalStyles.rowNavigations}>
            <NavLink
              className={({ isActive }) =>
                `${globalStyles.rowNavigations__item} ${isActive ? globalStyles.active : ""}`
              }
              to={pathConstants.INVENTORY_RESTOCK_LOGS}
            >
              Restock Logs
            </NavLink>

            <NavLink
              className={({ isActive }) =>
                `${globalStyles.rowNavigations__item} ${isActive ? globalStyles.active : ""}`
              }
              to={pathConstants.INVENTORY_RESTOCK_DRAFTS}
            >
              Drafts
            </NavLink>
          </div>

          <div className={globalStyles.pageHeaders}>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
            >
              <primaryComponents.Button
                classNames="btn btn--primary ml-auto"
                onClick={() =>
                  navigate(pathConstants.INVENTORY_PRODUCTS_BULK_RESTOCK)
                }
              >
                <BulkRestockIcon />
                <span className="ml-2">Add Stock</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          <Outlet />
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default RestockCover;
